// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ix-0";
export var buttonContainer = "_ix-3";
export var cancelButton = "_ix-4";
export var headerSection = "_ix-6";
export var headerTitle = "_ix-9";
export var messageSideLeft = "_ix-1";
export var messageSideRight = "_ix-2";
export var orderNumberContainer = "_ix-7";
export var orderNumberLabel = "_ix-8";
export var submitButton = "_ix-5";